import { ArrowDropDown, ArrowDropUp, FiberManualRecord } from "@mui/icons-material";

const PriceStatus = ({ status = 1 }) => {
  const statusProcessed = Number(status);
  if(statusProcessed === 0) {
    return (
      <ArrowDropDown color="error" fontSize="large" />
    );
  }
  if(statusProcessed === 1) {
    return (
      <FiberManualRecord color="warning" fontSize="small" />
    );
  }
  if(statusProcessed === 2) {
    return (
      <ArrowDropUp color="success" fontSize="large" />
    );
  }
};

export default PriceStatus;